import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class MypageSchedule extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                MypageSchedule
            </div>
        );
    }
}

export default connect()(withRouter(MypageSchedule));


// WEBPACK FOOTER //
// ./src/pages/mypage/schedule.jsx